import React, { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Icon } from '@cld/icon';
import { ButtonMenu } from '@cld/button';
import { globalTheme } from '@cld/component-theme';
import CopyToClipboard from '@cld/copy-to-clipboard';
import { typography } from '@cld/typography';
import { setExported } from '../../../actions';
import { messages } from '../../../i18n';
import { useWidget } from '../../../selectors';

const Root = styled.div`
  display: flex;
`;

const BackButton = styled(ButtonMenu)`
  margin-right: ${globalTheme.spacing.xs};
`;

const UrlContainer = styled.div`
  background-color: ${globalTheme.palette.background};
  flex: 1;
  display: flex;
  border-radius: ${globalTheme.radius.lg};
`;

const UrlText = styled.div`
  flex: 1;
  padding: ${globalTheme.spacing.sm};
  ${typography.xs.url};
  word-break: break-word;
`;

const CopyIcon = styled(Icon)`
  color: ${globalTheme.palette.contrastLow};
`;

interface HeaderProps {
  url: string;
}

export const Header: FC<HeaderProps> = ({ url }) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const widget = useWidget();

  const handleBack = useCallback(() => {
    dispatch(setExported({ isExported: false }));
    widget.instance?.show();
  }, [dispatch, widget.instance]);

  return (
    <Root>
      <BackButton size="md" onClick={handleBack} data-test="after-export-back-button">
        <Icon name="arrowBack" />
      </BackButton>
      <UrlContainer>
        <UrlText>{url}</UrlText>
        <CopyToClipboard tooltipAfterText={formatMessage(messages['afterExport.tooltipAfterCopy'])} copiedValue={url}>
          <ButtonMenu size="md">
            <CopyIcon name="copy"/>
          </ButtonMenu>
        </CopyToClipboard>
      </UrlContainer>
    </Root>
  );
};
